module.exports = __webpack_public_path__ + "img/photo-0066.560c311b.jpg";